import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

import {
    addCurrency,
    CashSession,
    CashSessionEmployee,
    CashSessionSummary,
    FeatureKeys,
    LoadingService,
    multiplyCurrency,
    Organization,
    SubscriberComponent,
    subtractCurrency,
    Timecard,
    TimecardComponent,
    TipOutTypes
} from 'brewbill-lib';
import {debounce} from 'lodash';
import {ModalController} from '@ionic/angular';

@Component({
    selector: 'bb-cash-session-employees',
    templateUrl: './cash-session-employees.component.html',
    styleUrls: ['./cash-session-employees.component.scss'],
})
export class CashSessionEmployeesComponent extends SubscriberComponent implements OnChanges {
    @Input() cashSession: CashSession;
    @Input() cashSessionSummary: CashSessionSummary;
    @Input() organization: Organization;
    @Input() includeTotals = false;
    @Input() hoursOnly = false;
    @Input() editable = false;
    @Output() employeeClick = new EventEmitter<CashSessionEmployee>();
    @Output() remainingAmount = new EventEmitter<number>();
    @Output() refresh = new EventEmitter<any>();

    totalHours: number;
    totalCash: number;
    totalPayroll: number;
    total: number;
    remaining: number;

    tipOutTypes = TipOutTypes;
    featureKeys = FeatureKeys;

    constructor(
        private modalController: ModalController,
        private loadingService: LoadingService
    ) {
        super();
        this.initSession = debounce(this.initSession, 100);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initSession();
    }

    initSession() {
        if (!!this.cashSession.employees && this.cashSession.employees.length > 0) {
            const totalHours = this.cashSession.employees
                .reduce((accum, value) => accum += value.hours * 100, 0);
            this.totalHours = totalHours / 100;

            let totalCashTemp = 0;
            let totalPayrollTemp = 0;
            this.cashSession.employees.forEach(e => {
                e.percent = (e.hours * 100) / totalHours;
                e.expected = multiplyCurrency(this.cashSessionSummary.tipTotal, e.percent);
                totalCashTemp = addCurrency(totalCashTemp, e.cashTips);
                totalPayrollTemp = addCurrency(totalPayrollTemp, e.payrollTips);
            });

            this.totalCash = totalCashTemp;
            this.totalPayroll = totalPayrollTemp;
            this.total = addCurrency(totalCashTemp, totalPayrollTemp);
            this.remaining = subtractCurrency(this.cashSessionSummary.tipTotal, this.total);
            this.remainingAmount.emit(this.remaining);
        }
    }

    async editTimecard(event, timecard: Timecard) {
        if (!!event) {
            event.stopPropagation();
        }

        this.loadingService.present();

        const modal = await this.modalController.create({
            component: TimecardComponent,
            componentProps: {
                timecard
            }
        });

        modal.onDidDismiss().then(dataReturned => {
            if (dataReturned) {
                this.refresh.emit();
            }
        });

        await modal.present();
        this.loadingService.dismiss();
    }
}
